import { buildProps, definePropType } from '@ll-plus/utils'

import type { CSSProperties, ExtractPropTypes } from 'vue'
import type { TooltipProps } from '../../tooltip/src/tooltip'
import type IconBase from './icon-base.vue'

export const iconTypes = ['default', 'primary'] as const
export const iconBaseProps = buildProps({
  /**
   * @description icon的类型
   */
  iconType: {
    type: String,
    values: iconTypes,
  },
  /**
   * @description icon的class
   */
  class: {
    type: String,
  },
  /**
   * @description icon的style
   */
  style: {
    type: definePropType<CSSProperties>(Object),
  },
  /**
   * @description tooltip的class
   */
  tooltipClass: {
    type: String,
  },
  /**
   * @description 是否显示tooltip
   */
  isShowTooltip: {
    type: Boolean,
    default: true,
  },
  /**
   * @description tooltip的提示语
   */
  tooltipTitle: {
    type: String,
  },
  tooltipProps: {
    type: definePropType<TooltipProps>(Object),
    default: () => ({}),
  },
  /**
   * @description 是否显示button的容器
   */
  isShowContainer: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 是否禁用
   */
  disabled: {
    type: Boolean,
  },
  /**
   * @description icon的name
   */
  iconName: {
    type: String,
  },
  /**
   * @description 是否显示icon右边的文字
   */
  isShowTitle: {
    type: Boolean,
  },
  /**
   * @description 点击按钮传递的数据
   */
  data: {
    type: definePropType<any>(undefined),
  },
  /**
   * @description 按钮点击事件
   */
  onClick: {
    type: Function,
  },
  /**
   * @description 是否显示icon
   */
  isShow: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 悬浮提示背景是否为白色
   */
  isWhiteBg: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 悬浮提示是否显示箭头
   */
  arrow: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type IconBaseProps = ExtractPropTypes<typeof iconBaseProps>
export type IconTypes = IconBaseProps['iconType']

// instance
export type IconBaseInstance = InstanceType<typeof IconBase>
